<template>
  <div class="container-fluid">
    <!-- <div class="row page-title align-items-center">
      
      <div class="col-md-1 col-xl-1">
        <h4 class="mb-1 mt-0" v-if="type == 'all'" >{{$t('application.all')}}</h4>
        <h4 class="mb-1 mt-0" v-else-if="type == 'consent'" >{{$t('application.consent_only')}}</h4>
        <h4 class="mb-1 mt-0" v-else-if="type == 'application'">{{$t('application.application_only')}}</h4>
        <h4 class="mb-1 mt-0" v-else>Filtering</h4> -->
        <!-- <button v-if="user.role.role == 'administration'" class="btn btn-warning mr-1 mb-3 mb-sm-0" @click="syncData">
          <i class="uil-sync mr-1"></i> {{$t('company.action.sync')}}
        </button> 
      </div> 
      <div class="col-md-12 col-xl-12 text-md-center">
        <div class="mt-4 mt-md-0">
          <div class="btn-group ml-1" ref="filterButton">
            <button type="button" class="btn btn-white-pink" @click="toggleFilter" value="all">{{$t('application.all')}}</button>
            <button type="button" class="btn btn-white-pink" @click="toggleFilter" value="consent">
              {{$t('application.consent_only')}}
            </button>
            <button type="button" class="btn btn-white-pink" @click="toggleFilter" value="application">
              {{$t('application.application_only')}}
            </button>
            <button type="button" class="btn btn-white-pink" @click="toggleFilter" value="filtering">
              Filtering
            </button>
          </div>
        </div> -->

        <!-- <button
          class="custom-chip chip-filter mr-1"
          :class="{ 'chip-filter-active': status.active }"
          v-for="(status, idx) in statusOptions"
          :key="idx"
          @click="$refs.table.filterByStatus(status)"
        >
          <span>{{ status.text }}</span>
          <span class="chip-total px-1 ml-3"><span>{{ status.total }}</span></span>
        </button> 
      </div>
    </div> -->
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <DataTable 
          v-if="type != 'filtering'"
          ref="table"
          :initialLoad="true"
          :syncData="syncData"
          @fetchFilter="fetchFilter"
        />
        <DataTable4
          v-else
          ref="list"
          :sent="true"
          :syncData="syncData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './table'
import DataTable4 from '@common/datatable4'

// const _types = {
//   all:0,
//   consent:1,
//   application:2,
// }
export default {
  data() {
    return {
      type: 'all',
      statusOptions: []
    }
  },
  components: {
    DataTable,
    DataTable4 
  },
  methods:{
    toggleFilter(e) {
      let filterButton = this.$refs['filterButton'],
        children = filterButton.children
      this.type = e.target.value
      for(var key in children){
        if(typeof children[key] == 'object'){
          children[key].classList.add('btn-white-pink')
          children[key].classList.remove('btn-pink')
        }
      }

      if(e.target){
        e.target.classList.add('btn-pink')
        e.target.classList.remove('btn-white-pink')
      }

      if(this.$refs['table'])
        this.$refs['table'].fetchData(e.target ? e.target.value : 'all')
    },
    syncData(){
      if(this.$refs.table){
        this.$refs.table.syncDatas()
      }
      else{
        this.$refs.list.syncDatas()
      }
      
    },
    fetchFilter(val) {
      // this.statusOptions = []
      // this.statusOptions = [ ...val ]
      this.statusOptions = val
    }
  },
  mounted(){
    // this.toggleFilter({
    //   target: this.$refs['filterButton'].children[_types[this.$route.query.type || 'all']]
    // })
  }
}
</script>